"use client";

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Camera, Thermometer, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServicesHighlights() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    icon: Camera,
    title: "Aerial Photography & Video",
    description: "High-resolution drone photography and video services for commercial and industrial projects across Central Texas and DFW Metroplex."
  }, {
    icon: Thermometer,
    title: "Thermal Imaging",
    description: "This professional-grade aerial imaging system features a powerful quad-sensor array, headlined by triple 48MP RGB cameras (Wide, Medium Tele, and Telephoto) that deliver unmatched clarity across focal lengths. With up to 16x optical zoom for detailed inspections from a distance for roof inspections, search-and-rescue operations, and comprehensive building assessments."
  }, {
    icon: MapPin,
    title: "Mapping & Surveys",
    description: "Precision aerial surveys with 3D modeling, digital elevation maps, and near-infrared imaging for superior project accuracy."
  }];
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div ref={ref1} data-index={0} className={`transition-all duration-[var(--duration-fast)] ${isVisible1 ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
            <Card className="h-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium hover:bg-[hsl(0,0%,99%)] border border-border">
              <CardHeader className="text-center pb-4">
                <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-primary/10">
                  <Camera className="h-8 w-8 text-primary" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-xl font-display">{services[0].title}</CardTitle>
              </CardHeader>
              <CardContent className="text-center">
                <CardDescription className="text-base leading-relaxed"><span style={{
                  color: 'rgb(10, 10, 10)',
                  fontFamily: '&quot',
                  textAlign: 'start',
                  backgroundColor: 'rgb(255, 255, 255)'
                }}>The M4T features a 640×512 radiometric thermal camera, essential for detecting temperature differences caused by trapped moisture in roofs. It is optimized for low-light conditions, allowing for accurate night-time inspections, which are often required for proper thermal contrast.</span></CardDescription>
              </CardContent>
            </Card>
          </div>

          <div ref={ref2} data-index={1} className={`transition-all duration-[var(--duration-fast)] ${isVisible2 ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`} style={{
          transitionDelay: "100ms"
        }}>
            <Card className="h-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium hover:bg-[hsl(0,0%,99%)] border border-border">
              <CardHeader className="text-center pb-4">
                <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-secondary/10">
                  <Thermometer className="h-8 w-8 text-foreground" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-xl font-display">{services[1].title}</CardTitle>
              </CardHeader>
              <CardContent className="text-center">
                <CardDescription className="text-base leading-relaxed">
                  {services[1].description}
                </CardDescription>
              </CardContent>
            </Card>
          </div>

          <div ref={ref3} data-index={2} className={`transition-all duration-[var(--duration-fast)] ${isVisible3 ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`} style={{
          transitionDelay: "200ms"
        }}>
            <Card className="h-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium hover:bg-[hsl(0,0%,99%)] border border-border">
              <CardHeader className="text-center pb-4">
                <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-accent/20">
                  <MapPin className="h-8 w-8 text-accent-dark" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-xl font-display">{services[2].title}</CardTitle>
              </CardHeader>
              <CardContent className="text-center">
                <CardDescription className="text-base leading-relaxed">
                  {services[2].description}
                </CardDescription>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}